import { topicsApi } from "api";
import { routes } from "consts";
import React from "react";
import { useNavigate } from "react-router-dom";
import { TopicForm, TopicFormValues } from "./TopicForm/TopicForm";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { timeToMinutes } from "utils";
import { PageMain } from "components/molecules";
import { useToaster } from "utils";
import { PaziaBox } from "components/atoms";

export const TopicAddPage = (): JSX.Element | null => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: TopicFormValues) => {
    try {
      const { time, ...request } = data;

      await topicsApi.create({ ...request, time: timeToMinutes(time) });
      showSuccess("Temat został dodany");
      navigate(routes.TOPICS);
    } catch (e) {
      console.error(e);
      showError("Nie udało się dodać tematu");
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[{ title: "Tematy", path: routes.TOPICS }, { title: "Tworzenie nowego tematu" }]}
        headerText="Dodaj nowy temat"
      />
      <PaziaBox>
        <TopicForm onSubmit={onSubmit} />
      </PaziaBox>
    </PageMain>
  );
};
